import { alpha, Button, Card, Chip, Menu, styled, TextField } from "@mui/material";
import { AppTheme } from "../theme";


export const SearchTextField = styled(TextField)(({ theme }) => ({
    backgroundColor: (theme as AppTheme).palette.neutral_4,
    width: "100%",
    borderRadius: "10px",
    '& label': {
        color: (theme as AppTheme).palette.neutral_2,
    },
    '& .MuiInputBase-input': {
        color: (theme as AppTheme).palette.neutral_0,
    },
    '& fieldset': {
        borderColor: (theme as AppTheme).palette.neutral_4,
        borderRadius: "10px"
    },
}));

export const FilterChip = styled(Chip)(({ theme }) => ({
    color: theme.palette.secondary.main,
    backgroundColor: alpha(theme.palette.secondary.main, 0.20),
    fontWeight: 500,
    fontSize: "13px",
    '& .MuiChip-deleteIcon': {
        color: alpha(theme.palette.secondary.main, 0.75)
    },
    '& .MuiChip-deleteIcon:hover': {
        color: theme.palette.secondary.main
    },
    margin:5
}));


export const CardApp = styled(Card)(({ theme }) => ({
    backgroundColor: (theme as AppTheme).palette.neutral_5,
    boxShadow: `0px 0.56px 1.69px 0px ${(theme as AppTheme).palette.neutral_3}, 0px 0.26px 4.52px 1.69px ${(theme as AppTheme).palette.neutral_3}`,
    "& .MuiCard-root": {
        color: (theme as AppTheme).palette.neutral_0,
    }
}));

export const MenuApp = styled(Menu)(({ theme }) => ({
    "& .MuiPaper-root": {
        color: (theme as AppTheme).palette.neutral_0,
        backgroundColor: (theme as AppTheme).palette.neutral_5,
        boxShadow: `0px 0.56px 1.69px 0px ${(theme as AppTheme).palette.neutral_3}, 0px 0.26px 4.52px 1.69px ${(theme as AppTheme).palette.neutral_3}`
    }
}));

export const ButtonApp = styled(Button)(({ theme }) => ({
    borderRadius: "8px", 
    "&.Mui-disabled": {
        backgroundColor: (theme as AppTheme).palette.neutral_3,
        color: (theme as AppTheme).palette.neutral_2
    }
}));

export const TextFieldApp = styled(TextField)(({ theme }) => ({
    width: "100%",
    borderRadius: "8px",
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: (theme as AppTheme).palette.neutral_4,
    },
    "& .MuiInputBase-root.Mui-disabled": {
        "& > fieldset": {
            borderColor: (theme as AppTheme).palette.neutral_4,
        }
    },
    '.MuiOutlinedInput-root': {
        borderRadius: "8px",
        backgroundColor: (theme as AppTheme).palette.neutral_4,
    },
    '.MuiOutlinedInput-input': {
        color: (theme as AppTheme).palette.neutral_0,
    },
    '.MuiFormLabel-root': {
        color: (theme as AppTheme).palette.neutral_0,
    },
    '& .MuiInputBase-input': {
        color: (theme as AppTheme).palette.neutral_0,
    },
    '& .MuiFilledInput-root': {
        overflow: 'hidden',
        borderRadius: "8px",
        border: '1px solid',
        backgroundColor: (theme as AppTheme).palette.neutral_4,
        borderColor: (theme as AppTheme).palette.neutral_4,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-focused': {
            backgroundColor: 'transparent',
            boxShadow: `${alpha((theme as AppTheme).palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: (theme as AppTheme).palette.primary.main,
        },
    },
}));
